<template>
  <v-container
    v-bind="settings"
    v-on="listeners"
  >
    <slot></slot>
  </v-container>
</template>

<script>
export default {
  name: "SGPContainerComponent",
  computed: {
    settings () {
      return {
        ...this.$attrs
      }
    },
    listeners () {
      return {
        ...this.$listeners
      }
    },
  }
}
</script>